import { values } from 'ramda';
import { isFilterValueActive } from '../../utils/isFilterValueActive';
import { EagGridState, selectFilterValuesWithoutStaticFilters } from '../createEagGridStore';
import { useEagGridSelector } from '../useEagGridSelector';

/**
 * Returns true when there are active filters excluding any static filters
 * injected by the host via queryModifier.
 *
 * Uses isFilterValueActive to correctly handle the {value: X} wrapper shape
 * used by filter widgets — sanitizeObject cannot handle {value: null} tombstones
 * left behind when a filter is cleared (the outer key survives rejection because
 * {value: null} is neither nil nor empty, while the inner null only gets stripped
 * in the recursive pass leaving {key: {}} which isNotNilOrEmpty considers active).
 */
const selectIsFilterActive = (state: EagGridState): boolean => values(selectFilterValuesWithoutStaticFilters(state)).some(isFilterValueActive);
export function useIsFilterActive() {
  return useEagGridSelector(selectIsFilterActive);
}